import script from "./FlussiOre.vue?vue&type=script&setup=true&lang=js"
export * from "./FlussiOre.vue?vue&type=script&setup=true&lang=js"

import "./FlussiOre.vue?vue&type=style&index=0&id=c30b100c&scoped=true&lang=css"

import exportComponent from "/Users/giancotsu/Desktop/ASK/ask_file/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c30b100c"]])

export default __exports__